/**
 * Dependencies
 */
import {
    createProjectLink,
    shareProjectWithUser
} from '../../../../services/ProjectService'

/**
 * Update the project share form email
 *
 * @param  {Function} options.commit
 * @param  {String} value
 * @return {Void}
 */
const updateShareFormEmail = ({ commit, state }, value) => {
    commit('SET_SHARE_EMAIL', value)
    if (state.form.error) {
        commit('REMOVE_ERROR_MESSAGE')
    }
}

/**
 * Reset the share form
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetShareForm = ({ commit }) => {
    commit('RESET_SHARE_FORM')
}

/**
 * Update the selected project share level
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const updateSelectedLevel = ({ commit }, value) => {
    commit('SET_SHARE_LEVEL', value)
}

/**
 * Make request to share a given project
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
const shareProject = ({ commit, state }) => {
    commit('SUBMIT_SHARE_FORM')
    setTimeout(() => {
        shareProjectWithUser(
            state.form.email,
            state.form.level,
            state.project.id
        )
        .then(res => commit('PROJECT_SHARED_SUCCESS', res.data))
        .catch(err => commit('PROJECT_SHARED_FAILURE', err))
    }, 500)
}

/**
 * Set up the sharing dialog
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const setUpShareDialog = ({ commit }, project) => {
    commit('SET_SHARE_DIALOG', project)
}

/**
 * Reset the sharing dialog
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const tearDownShareDialog = ({ commit }) => {
    commit('RESET_SHARE_DIALOG')
    setTimeout(() => {
        commit('RESET_STATE')
    }, 300)
}

/**
 * Get a shareable link from the API
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
const generateShareLink = ({ commit, state }) => {
    commit('CREATE_LINK')
    return createProjectLink(state.project.id)
        .then(res => commit('CREATE_LINK_SUCCESS', res.data))
        .catch(err => commit('CREATE_LINK_FAILURE', err))
}

export default {
    shareProject,
    resetShareForm,
    setUpShareDialog,
    generateShareLink,
    tearDownShareDialog,
    updateSelectedLevel,
    updateShareFormEmail
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/share/actions.js